import { render, staticRenderFns } from "./ProvisionPreview.vue?vue&type=template&id=ca52da28&scoped=true"
import script from "./ProvisionPreview.vue?vue&type=script&lang=js"
export * from "./ProvisionPreview.vue?vue&type=script&lang=js"
import style0 from "./ProvisionPreview.vue?vue&type=style&index=0&id=ca52da28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca52da28",
  null
  
)

export default component.exports